import React from 'react'
import {
  Table, TableHead, TableRow, TableCell, TableBody, TableContainer,
  IconButton, Chip, Typography, Tooltip,
} from '@material-ui/core'
import { Edit, Delete, SwapHoriz, AccountTree } from '@material-ui/icons'
import { map } from 'lodash'
import { useTranslation } from 'react-i18next'
import {
  disponivel, corStatus, statusExibicao, labelAnoBase, ehComprador,
} from '../../titulos-lbc.helpers'

const fmt = (n) => Number(n || 0).toLocaleString('pt-BR', { maximumFractionDigits: 2 })

const Lista = ({
  titulos, podeEditar, onEditar, onExcluir, onTransferir, onVerCadeia,
}) => {
  const { t } = useTranslation()
  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>{t('titulosLbc.codigo')}</TableCell>
            <TableCell>{t('titulosLbc.geradora')}</TableCell>
            <TableCell>{t('titulosLbc.destinataria')}</TableCell>
            <TableCell>{t('titulosLbc.ecorregiao')}</TableCell>
            <TableCell align="center">{t('titulosLbc.anoBase')}</TableCell>
            <TableCell align="right">{t('titulosLbc.total')}</TableCell>
            <TableCell align="right">
              <Tooltip title={t('titulosLbc.resgatadaTooltip')} arrow>
                <span style={{ cursor: 'help' }}>{t('titulosLbc.resgatada')}</span>
              </Tooltip>
            </TableCell>
            <TableCell align="right">{t('titulosLbc.disponivel')}</TableCell>
            <TableCell>{t('titulosLbc.status')}</TableCell>
            {podeEditar && <TableCell />}
          </TableRow>
        </TableHead>
        <TableBody>
          {map(titulos, (tit) => {
            const st = statusExibicao(tit)
            return (
              <TableRow key={tit.id}>
                <TableCell>
                  <div style={{ fontFamily: 'monospace', fontSize: 12 }}>{tit.codigo}</div>
                  <Typography variant="caption" color="textSecondary">{tit.projeto?.nome || ''}</Typography>
                  {ehComprador(tit) && (
                    <Chip size="small" label={t('titulosLbc.comprado')} style={{ backgroundColor: '#31ADE3', color: '#fff', height: 18, marginTop: 2 }} />
                  )}
                </TableCell>
                <TableCell>{tit.empresaGeradora?.nome || '-'}</TableCell>
                <TableCell>{tit.empresaDestinataria?.nome || '-'}</TableCell>
                <TableCell>{tit.ecorregiao?.nome || '-'}</TableCell>
                <TableCell align="center">{labelAnoBase(tit.anoBase)}</TableCell>
                <TableCell align="right">{fmt(tit.quantidadeTotal)}</TableCell>
                <TableCell align="right">{fmt(tit.quantidadeResgatada)}</TableCell>
                <TableCell align="right">{fmt(disponivel(tit))}</TableCell>
                <TableCell>
                  <Chip
                    size="small"
                    label={t(`titulosLbc.statusValor.${st}`)}
                    style={{ backgroundColor: corStatus(st), color: '#fff' }}
                  />
                </TableCell>
                {podeEditar && (
                  <TableCell align="right" style={{ whiteSpace: 'nowrap' }}>
                    <IconButton aria-label="cadeia" size="small" title={t('titulosLbc.verCadeia')} onClick={() => onVerCadeia(tit)}>
                      <AccountTree fontSize="small" />
                    </IconButton>
                    <IconButton
                      aria-label="transferir" size="small" title={t('titulosLbc.transferir')}
                      disabled={!(Number(disponivel(tit)) > 0)}
                      onClick={() => onTransferir(tit)}
                    >
                      <SwapHoriz fontSize="small" />
                    </IconButton>
                    <IconButton aria-label="edit" size="small" onClick={() => onEditar(tit)}>
                      <Edit fontSize="small" />
                    </IconButton>
                    <IconButton aria-label="delete" size="small" onClick={() => onExcluir(tit)}>
                      <Delete fontSize="small" />
                    </IconButton>
                  </TableCell>
                )}
              </TableRow>
            )
          })}
          {titulos.length === 0 && (
            <TableRow>
              <TableCell colSpan={podeEditar ? 10 : 9}>
                <Typography variant="body2" color="textSecondary">
                  {t('titulosLbc.semRegistros')}
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default Lista
